import { useUserStore } from '../hooks/useGameState';

export const TRANSLATIONS = {
  tr: {
    // Header & General
    architecture: "MİMARİ",
    play_now: "HEMEN OYNA",
    all_rights_reserved: "Tüm Hakları Saklıdır",
    terms_of_use: "Kullanım Koşulları",
    cookie_policy: "Çerez Politikası",
    kvkk: "KVKK Aydınlatma Metni",
    rules: "Kurallar",
    settings: "Ayarlar",
    exit: "Çıkış",
    back: "Geri",
    save: "Kaydet",
    close: "Kapat",
    cancel: "İptal",
    language: "Dil",
    turkish: "Türkçe",
    english: "English",

    // Landing Page Features
    challenging_ai: "Zorlu Yapay Zeka",
    challenging_ai_desc: "Gelişmiş bot rakiplere karşı çevrimdışı/çevrimiçi kendinizi test edin.",
    offline_play: "İnternetsiz de Oyna",
    offline_play_desc: "İnternet bağlantınız olmasa bile kesintisiz oyun keyfi.",
    play_with_friends: "Arkadaşlarınla Oyna",
    play_with_friends_desc: "P2P bağlantı teknolojisiyle arkadaşlarınızla eş zamanlı odalar kurun.",
    lobby_system: "Turnuva & Lobi Sistemi",
    lobby_system_desc: "Kolay lobi yönetimi, oyuncu istatistikleri ve özelleştirilebilir kurallar.",
    footer_text: "Klasik Türk kart ve masa oyunlarını modern grafikler ve akıcı animasyonlarla tarayıcınızda oynayın.",

    // Lobby Steps
    choose_game: "OYUN SEÇİN",
    game_mode: "OYUN MODU",
    join_lobby: "LOBİYE KATIL",
    singleplayer: "Yapay Zeka (AI)",
    singleplayer_desc: "Gelişmiş bot rakiplere karşı internetsiz hızlı oyun.",
    multiplayer: "Arkadaşlarla Oyna (P2P)",
    multiplayer_desc: "Arkadaşlarınızla oda kodu paylaşarak eş zamanlı oynayın.",
    enter_name: "İsim Giriniz...",
    enter_lobby_id: "Lobi ID Giriniz...",
    connect: "Bağlan",
    host_game: "Oda Kur",
    join_room: "Odaya Katıl",
    back_to_games: "Oyun Seçimine Dön",
    connecting: "Bağlanılıyor...",

    // Game configurations
    pisti: "Pişti",
    batak: "Batak",
    king: "King",
    okey: "Okey",
    game_type: "Oyun Tipi",
    player_count: "Oyuncu Sayısı",
    target_score: "Hedef Skor",
    team_game: "Eşli Oyun",
    bluff_mode: "Blöf Modu",
    batak_variant: "Batak Türü",
    ihaleli: "İhaleli",
    kozmaca: "Kozmaca",
    gomulu: "Gömülü",
    esli: "Eşli",
    no_limit: "Sınırsız",

    // Table / In-Game Actions
    trump_selection: "KOZ SEÇİMİ",
    select_trump: "Koz Seç",
    bid: "İhale",
    bids: "İhaleler",
    pass: "Pas",
    points: "Puan",
    won: "Kazandı",
    lost: "Kaybetti",
    dealing: "Dağıtılıyor...",
    your_turn: "SIRA SENDE",
    game_over: "OYUN BİTTİ",
    winner: "Kazanan",
    play_again: "Yeniden Oyna",
    back_to_lobby: "Lobiye Dön",
    hand: "El",
    round: "Tur",
    scoreboard: "Skor Tablosu",
    trump: "Koz",
    score: "Skor",
    total: "Toplam",
    chat: "Sohbet",
    type_message: "Mesaj yazın...",
    send: "Gönder",
    ready: "Hazır",
    not_ready: "Hazır Değil",
    waiting_players: "Oyuncular bekleniyor...",

    // King Penalties / Trumps
    penalty: "Ceza",
    active_penalty: "Aktif Ceza",
    tricks: "El Almaz",
    hearts: "Kupa",
    girls: "Kız Almaz",
    boys: "Erkek Almaz",
    king_hearts: "Kupa Rıfkı",
    last_two: "Son İki",
    none: "Yok",

    // Okey Actions & States
    go_double: "Çift Git",
    show_indicator: "Gösterge Göster",
    draw_tile: "Taş Çek",
    discard_tile: "Taş At",
    group_tiles: "Grup Yap",
    run_tiles: "Seri Yap",
    okey_indicator: "Gösterge",
    player_rack: "Istanız",
    left_discard: "Sol Çöp",
    right_discard: "Sağ Çöp",

    // Sidebar & Profile
    profile: "Profil",
    stats: "İstatistikler",
    card_look: "Kart Tasarımı",
    sounds: "Sesler",
    on: "Açık",
    off: "Kapalı",
    games_played: "Toplam Oyun",
    games_won: "Kazanılan",
    total_score: "Toplam Skor",
    card_face: "Ön Yüz",
    card_back: "Arka Yüz",
    change_avatar: "Avatar Değiştir",
    custom_avatar: "Özel Yükle",
    theme: "Tema",
    cyan: "Turkuaz",
    emerald: "Zümrüt",
    violet: "Menekşe",
    rose: "Gül",
    amber: "Kehribar",
    blue: "Mavi",

    // Suits
    spades: "Maça",
    hearts_suit: "Kupa",
    diamonds: "Karo",
    clubs: "Sinek",

    // Game status overlays
    pisti_pisti: "PİŞTİ!",
    pisti_double: "ÇİFT PİŞTİ!",
    invalid_move: "Geçersiz Hamle!",
    must_follow_suit: "Aynı rengi takip etmelisiniz!",
    must_play_trump: "Koz oynamalısınız!"
  },
  en: {
    // Header & General
    architecture: "ARCHITECTURE",
    play_now: "PLAY NOW",
    all_rights_reserved: "All Rights Reserved",
    terms_of_use: "Terms of Use",
    cookie_policy: "Cookie Policy",
    kvkk: "Privacy Policy (KVKK)",
    rules: "Rules",
    settings: "Settings",
    exit: "Exit",
    back: "Back",
    save: "Save",
    close: "Close",
    cancel: "Cancel",
    language: "Language",
    turkish: "Türkçe",
    english: "English",

    // Landing Page Features
    challenging_ai: "Challenging AI",
    challenging_ai_desc: "Test yourself against advanced bot opponents offline or online.",
    offline_play: "Play Offline",
    offline_play_desc: "Seamless gaming experience even without an internet connection.",
    play_with_friends: "Play with Friends",
    play_with_friends_desc: "Host real-time game rooms with friends using peer-to-peer technology.",
    lobby_system: "Lobby & Tournament System",
    lobby_system_desc: "Easy lobby management, player stats, and customizable rules.",
    footer_text: "Play classic Turkish card and board games in your browser with modern graphics and smooth animations.",

    // Lobby Steps
    choose_game: "CHOOSE GAME",
    game_mode: "GAME MODE",
    join_lobby: "JOIN LOBBY",
    singleplayer: "Play vs AI (Offline)",
    singleplayer_desc: "Quick offline games against smart bot opponents.",
    multiplayer: "Play with Friends (P2P)",
    multiplayer_desc: "Share your room code to play with friends in real-time.",
    enter_name: "Enter Name...",
    enter_lobby_id: "Enter Lobby ID...",
    connect: "Connect",
    host_game: "Host Game",
    join_room: "Join Room",
    back_to_games: "Back to Game Selection",
    connecting: "Connecting...",

    // Game configurations
    pisti: "Pisti",
    batak: "Batak",
    king: "King",
    okey: "Okey",
    game_type: "Game Type",
    player_count: "Players Count",
    target_score: "Target Score",
    team_game: "Team Game",
    bluff_mode: "Bluff Mode",
    batak_variant: "Batak Variant",
    ihaleli: "Bidding",
    kozmaca: "Trump Only",
    gomulu: "Buried",
    esli: "Partnership",
    no_limit: "Unlimited",

    // Table / In-Game Actions
    trump_selection: "TRUMP SELECTION",
    select_trump: "Select Trump",
    bid: "Bid",
    bids: "Bids",
    pass: "Pass",
    points: "Points",
    won: "Won",
    lost: "Lost",
    dealing: "Dealing...",
    your_turn: "YOUR TURN",
    game_over: "GAME OVER",
    winner: "Winner",
    play_again: "Play Again",
    back_to_lobby: "Back to Lobby",
    hand: "Hand",
    round: "Round",
    scoreboard: "Scoreboard",
    trump: "Trump",
    score: "Score",
    total: "Total",
    chat: "Chat",
    type_message: "Type a message...",
    send: "Send",
    ready: "Ready",
    not_ready: "Not Ready",
    waiting_players: "Waiting for players...",

    // King Penalties / Trumps
    penalty: "Penalty",
    active_penalty: "Active Penalty",
    tricks: "No Tricks",
    hearts: "No Hearts",
    girls: "No Queens",
    boys: "No Kings/Jacks",
    king_hearts: "No King of Hearts",
    last_two: "Last Two",
    none: "None",

    // Okey Actions & States
    go_double: "Go Double",
    show_indicator: "Show Indicator",
    draw_tile: "Draw Tile",
    discard_tile: "Discard Tile",
    group_tiles: "Group Group",
    run_tiles: "Group Run",
    okey_indicator: "Indicator",
    player_rack: "Your Rack",
    left_discard: "Left Pool",
    right_discard: "Right Pool",

    // Sidebar & Profile
    profile: "Profile",
    stats: "Statistics",
    card_look: "Card Skins",
    sounds: "Sounds",
    on: "On",
    off: "Off",
    games_played: "Games Played",
    games_won: "Games Won",
    total_score: "Total Score",
    card_face: "Card Face",
    card_back: "Card Back",
    change_avatar: "Change Avatar",
    custom_avatar: "Upload Custom",
    theme: "Theme",
    cyan: "Cyan",
    emerald: "Emerald",
    violet: "Violet",
    rose: "Rose",
    amber: "Amber",
    blue: "Blue",

    // Suits
    spades: "Spades",
    hearts_suit: "Hearts",
    diamonds: "Diamonds",
    clubs: "Clubs",

    // Game status overlays
    pisti_pisti: "PISTI!",
    pisti_double: "DOUBLE PISTI!",
    invalid_move: "Invalid Move!",
    must_follow_suit: "You must follow the lead suit!",
    must_play_trump: "You must play a trump card!"
  }
};

export function useTranslation() {
  const language = useUserStore((state) => state.language);
  const setLanguage = useUserStore((state) => state.setLanguage);

  const t = (key: keyof typeof TRANSLATIONS.tr): string => {
    return TRANSLATIONS[language][key] || TRANSLATIONS.tr[key] || String(key);
  };

  return { t, language, setLanguage };
}
